<section class="new_dashboard" *ngIf="!loader">
    <div class="wel_sectionm" *ngIf="businessListData.length == 0 && !loaderForBusiness">
       <mat-card>
        <h3>Welcome, {{userDetail.name}}</h3>
          <p>Let's start your journey with creating a new business or professional service. You can add one or many. </p>
          <p>Start using the platform features, functionality and see a rocketing growth in your business.</p>
          <div class="Create_new_business_btn" style="margin-top: 10px;    display: flex;">
            <div class="newd_seb">
             <button (click)="selectcountry()" mat-stroked-button color="primary">
                <mat-icon>add</mat-icon>
                 New business
             </button>
            </div>
            <div class="newd_help">
             <button mat-stroked-button color="primary" (click)="openvideo()">
               See the help video
            </button>
         </div>
          </div>
       </mat-card>
    </div>

    <div class="welcome_heading" *ngIf="businessListData.length > 0 && !loaderForBusiness">
      <div class="business_bth">
      <h3>Welcome, {{userDetail.name}}</h3>
      <p>{{userDetail.addressInfo ? userDetail.addressInfo.address_line : 'No address info'}}</p>
    </div>
      <!-- <div class="create_busin_btn">
        <button mat-stroked-button color="primary" (click)="createNewBusiness()">
          <mat-icon>add</mat-icon>
           New business
       </button>
      </div> -->
  </div>
    <div class="row">
      
       <div class="col-sm-6">
        <sm-todays-bookings></sm-todays-bookings>
       </div>
       <div class="col-sm-6">
        <sm-upcoming-appointments></sm-upcoming-appointments>
       </div>
       <div class="col-sm-6">
        <sm-unpaid-invoices></sm-unpaid-invoices>
       </div>
       <div class="col-sm-6">
        <sm-latest-purchases></sm-latest-purchases>
       </div>
       <div class="col-sm-6">
          <sm-inventory-status></sm-inventory-status>
       </div>
       <div class="col-sm-6">
        <sm-employee-log></sm-employee-log>
       </div>
    </div>



<div class="upcom_sectionmk">
    <div class="row">
             <!-- Expenditure start -->
             <div class="col-sm-4">
                <sm-daily-booking-graph></sm-daily-booking-graph>
               </div>
               <div class="col-sm-4">
                <sm-daily-sales-graph></sm-daily-sales-graph>
               </div>
               <div class="col-sm-4">
                <sm-expenditure-graph></sm-expenditure-graph>
               </div>
            <!-- Inventory status end-->
    </div>
  </div>

            <!-- open Messaging section -->
            
        
            <!-- open Messaging section end -->


 </section>